import React, { useEffect, useRef } from "react";
import { isDevOmgeving } from "../../utils/omgeving";
import styles from "./DevBalk.module.css";

/**
 * Rode balk bovenaan elk scherm van de DEV-omgeving (ook de inlogpagina), zodat
 * niemand per ongeluk in de zandbak "echt" gaat werken.
 *
 * De poort (`isDevOmgeving`) staat in `utils/omgeving.ts` en wordt hier
 * opnieuw geëxporteerd voor bestaande importeurs.
 */
export { isDevOmgeving };

const DevBalk: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const zichtbaar = isDevOmgeving();

  // De hamburger van NavMenu staat position:fixed; hij schuift via deze
  // variabele precies de hoogte van de balk omlaag (zie NavMenu.module.css).
  useEffect(() => {
    if (!zichtbaar || !ref.current) return;
    const root = document.documentElement;
    const zetHoogte = () =>
      root.style.setProperty(
        "--dev-balk-hoogte",
        `${ref.current?.offsetHeight ?? 0}px`,
      );
    zetHoogte();
    const observer =
      typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(zetHoogte);
    observer?.observe(ref.current);
    return () => {
      observer?.disconnect();
      root.style.removeProperty("--dev-balk-hoogte");
    };
  }, [zichtbaar]);

  if (!zichtbaar) return null;

  return (
    <div ref={ref} className={styles.balk} role="note">
      <strong>Dit is de DEV-versie:</strong> een zandbak om te oefenen. Alles
      mag hier, maar werk hier niet echt.
    </div>
  );
};

export default DevBalk;
